import { render } from "./ConfirmLogout.vue?vue&type=template&id=5fdeecef&scoped=true"
import script from "./ConfirmLogout.vue?vue&type=script&lang=js"
export * from "./ConfirmLogout.vue?vue&type=script&lang=js"

import "./ConfirmLogout.vue?vue&type=style&index=0&id=5fdeecef&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fdeecef"]])

export default __exports__